// SDK install snippets — the only place the console names the web SDK's package and API.

export const WEB_PACKAGE = "@atrix.dev/analytics-web";
export const WEB_INSTALL = `npm install ${WEB_PACKAGE}`;

export function webSnippet(publicKey: string): string {
  return `import { init, track, identify } from "${WEB_PACKAGE}";

// The key is write-only and safe to ship in client code.
// Its region prefix tells the SDK which ingest host to use.
init("${publicKey}");

// Track what people do…
track("signed_up", { plan: "free" });

// …and who they are, once they sign in.
identify(user.id, { email: user.email });`;
}
